import { Action } from '../../definitions/types';
import * as Actions from '../actions/actions-consts';

export default function activeType(
  state: string = null,
  action: Action<any> // tslint:disable-line no-any
): string {
  switch (action.type) {
    case Actions.ACTIVE_DOMAIN_TYPE_SELECTED:
      return action.payload;
    default:
      return state;
  }
}
